import React from 'react';
import { SidebarItem, SidebarItemProps } from '..';

interface MainSidebarItemProps extends Omit<SidebarItemProps, 'children' | 'className'> {
  icon: React.ReactNode;
}

export default function MainSidebarItem({ open, icon, ...itemProps }: MainSidebarItemProps) {
  return (
    <SidebarItem {...itemProps} open={open} className={open ? 'mx-4' : 'mx-2 justify-center'}>
      {icon}
      {open && <p>{itemProps.title}</p>}
    </SidebarItem>
  );
}
